<td-address-page scope="reverse-records" #page *transloco="let t">
    <h1 my-title>{{ t('reverse-record-list.title-my') }}</h1>
    <span other-subtitle>{{ t('reverse-record-list.title-owned-by') }}</span>

    <td-reverse-record-table *ngIf="page.validAddress" [address]="page.address"></td-reverse-record-table>
</td-address-page>
